export default "__VITE_ASSET__O6I4Pgha__"